import { render, staticRenderFns } from "./protocol_item_base.vue?vue&type=template&id=faa4af04"
import script from "./protocol_item_base.vue?vue&type=script&lang=js"
export * from "./protocol_item_base.vue?vue&type=script&lang=js"
import style0 from "./protocol_item_base.vue?vue&type=style&index=0&id=faa4af04&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports